"use client";

import Link from "next/link";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

export default function HeaderTransparent({ data }) {
  const { logo, menu = [], cta, layout = {} } = data;
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const isSticky = layout?.sticky;
  const positionClass = isSticky ? "fixed top-0" : "absolute top-0";
  const bgClass = scrolled ? "bg-white shadow-md" : "bg-transparent";
  const textColor = scrolled ? "text-foreground" : "text-primary-foreground";

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 80); // thay đổi ngưỡng tại đây nếu cần
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`w-full z-50 transition-colors duration-300 ${positionClass} ${bgClass}`}
    >
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center ">
        {/* Logo */}
        <Link href="/">
          <img
            src={logo?.src}
            alt={logo?.alt || "Logo"}
            className="h-8 w-auto"
          />
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center space-x-6">
          {menu.map((item, idx) => (
            <Link
              key={idx}
              href={item.href || "#"}
              className={`text-sm font-medium ${textColor} hover:text-primary`}
            >
              {item.label}
            </Link>
          ))}
          {cta && (
            <Link
              href={cta.href}
              className={`ml-4 px-4 py-2 rounded ${
                cta.style === "primary"
                  ? "bg-primary text-primary-foreground hover:bg-primary/80"
                  : cta.style === "secondary"
                    ? "bg-secondary text-secondary-foreground hover:bg-secondary/80"
                    : "text-primary underline hover:opacity-80"
              }`}
            >
              {cta.text}
            </Link>
          )}
        </nav>

        {/* Mobile Toggle */}
        <button
          onClick={() => setOpen(!open)}
          className={`md:hidden ${textColor}`}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      {open && (
        <div className="md:hidden bg-popover text-popover-foreground pb-8">
          <div className="flex flex-col px-4 py-2 space-y-2">
            {menu.map((item, idx) => (
              <Link
                key={idx}
                href={item.href || "#"}
                className="text-sm font-medium hover:text-primary"
              >
                {item.label}
              </Link>
            ))}
            {cta && (
              <Link
                href={cta.href}
                className={`mt-2 px-4 py-2 text-center rounded ${
                  cta.style === "primary"
                    ? "bg-primary text-primary-foreground"
                    : cta.style === "secondary"
                      ? "bg-secondary text-secondary-foreground"
                      : "text-primary underline"
                }`}
              >
                {cta.text}
              </Link>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
